module.exports = __webpack_public_path__ + "static/img/son6.39f4fd8b.png";